// import { dicoGenerated } from "./generated";
export interface DicoCtrlCallback {
  (path: string, isGroup: boolean): void;
}
let callback: DicoCtrlCallback;

export interface DicoCtrlOptions {
  selectId: string;
  whereToShowId: string;
  insertBtnId: string;
  searchBtnId: string;
  searchBarId: string;
  excelWordSelectId: string;
  versionSelectId: string;
  callback: DicoCtrlCallback;
}

export class DicoCtrl {
  public readonly options: Readonly<DicoCtrlOptions>;
  constructor(options: DicoCtrlOptions) {
    this.options = options;
    callback = options.callback;
  }
  public init() {
    const dicoCtrl = this;
    const generatedSelectDiv = document.getElementById(this.options.selectId);
    if (generatedSelectDiv) {
      const selectList = document.createElement("select");
      selectList.classList.add("form-select");
      selectList.classList.add("form-select-sm");
      selectList.classList.add("margin-top-1");
      selectList.id = "generatedSelect";
      generatedSelectDiv.appendChild(selectList);
      var optDefault = document.createElement("option");
      optDefault.text = "-- Sélectionner une source de champs --";
      selectList.appendChild(optDefault);
      const windowAny: any = window;
      const getDicoChoice = function (this: any) {
        const datas = windowAny.dicoGenerated[this.value]?.schemas?.properties;
        const whereToShow = document.getElementById(dicoCtrl.options.whereToShowId);
        whereToShow.innerHTML = "";

        const ul = document.createElement("ul");
        ul.id = "myUL";
        whereToShow.appendChild(ul);
        loopThatShowEverything(datas, "no-marg-no-pad", "myUL");
        const toggler = document.getElementsByClassName("caret");
        for (let i = 0; i < toggler.length; i++) {
          toggler[i].addEventListener("click", function () {
            const childId = "#" + this.getAttribute("childId");
            this.parentElement.querySelector(childId).classList.toggle("active");
            this.classList.toggle("caret-down");
          });
        }
        justChangeTheDataMain();
        versionChange();
        new ClassWatcher(
          ul,
          "actif",
          visibilityClassTrigger(dicoCtrl.options.insertBtnId, true),
          visibilityClassTrigger(dicoCtrl.options.insertBtnId, false)
        );

        (<HTMLInputElement>document.getElementById("searchbar")).value = "";
        versionChange();
      };

      for (const item in windowAny.dicoGenerated) {
        var option = document.createElement("option");
        option.value = item;
        option.text = item;
        selectList.appendChild(option);

        selectList.addEventListener("change", getDicoChoice);
      }
    }
    const el = document.getElementById(dicoCtrl.options.insertBtnId);
    if (el) {
      el.addEventListener("click", insertTag);
    }
    const searchbutton = document.getElementById(dicoCtrl.options.searchBtnId);
    if (searchbutton) {
      searchbutton.addEventListener("click", searchAction);
    }
    const searchbar = document.getElementById(dicoCtrl.options.searchBarId);
    const textareaToFill = document.getElementById("textareaToFill");
    const insertButton = document.getElementById(dicoCtrl.options.insertBtnId);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        if (document.activeElement === searchbar) {
          searchbutton.click();
        } else if (document.activeElement === textareaToFill) {
          // do nothing
        } else {
          insertButton.click();
        }
      }
    });
    const excelWordSelect = document.getElementById(dicoCtrl.options.excelWordSelectId);
    if (excelWordSelect) {
      excelWordSelect.addEventListener("change", justChangeTheDataMain);
    }
    const versionSelect = document.getElementById(dicoCtrl.options.versionSelectId);
    if (versionSelect) {
      versionSelect.addEventListener("change", versionChange);
    }
  }
}
class ClassWatcher {
  targetNode;
  classToWatch;
  classAddedCallback;
  classRemovedCallback;
  observer;
  lastClassState;

  constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
    this.targetNode = targetNode;
    this.classToWatch = classToWatch;
    this.classAddedCallback = classAddedCallback;
    this.classRemovedCallback = classRemovedCallback;
    this.observer = null;
    this.lastClassState = targetNode.classList.contains(this.classToWatch);
    this.init();
  }

  init() {
    if (this.classToWatch === "actif") {
      this.observer = new MutationObserver(this.mutationCallback);
      this.observe();
    }
  }

  observe(node = null) {
    if (node === null) {
      node = this.targetNode;
    } else {
      this.observer.observe(node, { attributes: true });
    }
    node = node || this.targetNode;
    const children = node.children;
    for (var i = 0; i < children.length; i++) {
      const child = children[i];
      this.observe(child);
    }
  }

  disconnect() {
    this.observer.disconnect();
  }
  mutationCallback = (mutationsList) => {
    let exist = false;
    for (let mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        let currentClassState = mutation.target.classList.contains(this.classToWatch);
        if (currentClassState) exist = true;
        if (exist) {
          this.classAddedCallback();
        } else {
          this.classRemovedCallback();
        }
      }
    }
  };
}
let lastId = 0;
export function loopThatShowEverything(datas, classname, parent, parentPath = null) {
  const whereToShow = document.getElementById(parent);
  const exWord = <HTMLInputElement>document.getElementById("excelWord");
  const excelWord = exWord ? exWord.value : "";
  for (const data in datas) {
    const value = datas[data];
    const p = document.createElement("li");
    const isArray = value.type === "array";
    p.addEventListener("click", function () {
      if (isArray) {
        addActiveArray(p);
      } else {
        addActive(p);
      }
    });
    p.classList.add(classname);
    p.textContent = value.description ? data + " - " + value.description : data;
    const path = parentPath ? parentPath + "/" + data : data;
    p.setAttribute("data", path);
    p.setAttribute("dataWeb", "{" + data + "}");
    p.setAttribute("puredata", data);
    p.setAttribute("versionContent", value.version || 0);
    if (excelWord === "excel" && parent !== "myUL") {
      const parentUL = document.querySelector('[childId="' + parent + '"]');
      const parentData = parentUL.getAttribute("puredata");
      if (parentData !== "liste") p.setAttribute("dataWeb", "{table:" + parentData + "." + data + "}");
    }
    whereToShow.appendChild(p);
    if (value.type === "array") {
      const parent = document.createElement("ul");
      parent.id = `ID${++lastId}`;
      parent.classList.add("nested");
      p.setAttribute("childId", parent.id);
      p.setAttribute("isGroup", "true");
      p.setAttribute("dataWeb", "{#" + data + "}" + "{/" + data + "}");
      p.setAttribute("puredata", data);
      p.classList.add("caret");
      whereToShow.appendChild(parent);
      const newValues = value.items.properties;
      const cls = parentPath ? "marg10" : "marg5";
      loopThatShowEverything(newValues, cls, parent.id, path);
    }
  }
}
function setElementVisibilityClass(element, visibility) {
  const clsToAdd = visibility ? "visible" : "invisible";
  element.classList.remove(clsToAdd === "visible" ? "invisible" : "visible");
  element.classList.add(clsToAdd);
}

function visibilityClassTrigger(elementId, visibility) {
  return () => {
    const el = document.getElementById(elementId);
    setElementVisibilityClass(el, visibility);
  };
}
function removeActive(element) {
  const children = element.children;
  for (let i = 0; i < children.length; i++) {
    removeActive(children[i]);
  }
  element.classList.remove("actif");
}
function addActive(element) {
  if (element.classList.contains("actif")) {
    return; //element.classList.remove("actif");
  } else {
    const whereToShow = document.getElementById("myUL");
    removeActive(whereToShow);
    element.classList.add("actif");
  }
}

function addActiveArray(element) {
  if (element.classList.contains("actif")) {
    // && element.classList.contains("caret-down")) {
    // element.classList.remove("actif");
    return;
  } else {
    const whereToShow = document.getElementById("myUL");
    removeActive(whereToShow);
    element.classList.add("actif");
  }
}
function insertTag() {
  const el = document.getElementsByClassName("actif");
  const path = el[0].getAttribute("data");
  const isGroup = el[0].getAttribute("isGroup") === "true";
  callback(path, isGroup);
}

export function versionChange() {
  const version = (<HTMLInputElement>document.getElementById("version")).value;
  const ul = document.getElementById("myUL");
  if (ul) {
    const lis = ul.getElementsByTagName("li");
    for (let i = 0; i < lis.length; i++) {
      if (version === "upToDate") {
        lis[i].style.display = "";
      }
      const versionValue = lis[i].getAttribute("versionContent");
      if (versionValue < version) {
        lis[i].style.display = "";
      } else {
        lis[i].style.display = "none";
      }
      const childId = lis[i].getAttribute("childId");
      if (childId && versionValue < version) {
        const ulParent = document.getElementById(childId);
        ulParent.style.display = "";
      }
      if (childId && versionValue > version) {
        const ulParent = document.getElementById(childId);
        ulParent.style.display = "none";
      }
    }
  }
  (<HTMLInputElement>document.getElementById("searchbar")).value = "";
}
export function searchAction() {
  const searchbar = (<HTMLInputElement>document.getElementById("searchbar"))?.value?.toUpperCase();
  const version = (<HTMLInputElement>document.getElementById("version")).value;
  const ul = document.getElementById("myUL");
  if (ul) {
    const lis = ul.getElementsByTagName("li");
    for (let i = 0; i < lis.length; i++) {
      const versionValue = lis[i].getAttribute("versionContent");
      const txtValue = lis[i].textContent || lis[i].innerText;
      if (txtValue.toUpperCase().indexOf(searchbar) > -1 && versionValue < version) {
        lis[i].style.display = "";
      } else {
        lis[i].style.display = "none";
      }
      const childId = lis[i].getAttribute("childId");
      if (childId && versionValue < version) {
        lis[i].style.display = "";
        const ulParent = document.getElementById(childId);
        ulParent.style.display = "";
      }
      if (childId && versionValue > version) {
        lis[i].style.display = "none";
        const ulParent = document.getElementById(childId);
        ulParent.style.display = "none";
      }
    }
  }
}
function justChangeTheDataMain() {
  const generatedSelect = <HTMLInputElement>document.getElementById("generatedSelect");
  if (generatedSelect && generatedSelect.value) {
    justChangeTheData("myUL");
  }
}

function justChangeTheData(parent) {
  const exWord = <HTMLInputElement>document.getElementById("excelWord");
  const excelWord = exWord ? exWord.value : "";
  const ul = document.getElementById(parent);
  if (ul) {
    const datas = ul.getElementsByTagName("li");
    for (const data of datas) {
      const childId = data.getAttribute("childId");
      if (childId) justChangeTheData(childId);
      if (data.attributes["puredata"].value[0] === "%" && data.attributes["puredata"].value.includes("image")) {
        if (excelWord === "excel")
          data.setAttribute("dataWeb", "{image:" + data.attributes["puredata"].value.slice(1) + "}");
        else data.setAttribute("dataWeb", "{" + data.attributes["puredata"].value + "}");
      }
      if (parent === "myUL") continue;
      if (excelWord === "word" && !childId) data.setAttribute("dataWeb", "{" + data.attributes["puredata"].value + "}");
      if (excelWord === "excel") {
        const parentUL = document.querySelector('[childId="' + parent + '"]');
        if (parentUL) {
          const parentData = parentUL.getAttribute("puredata");
          if (parentData !== "liste") {
            data.setAttribute("dataWeb", "{table:" + parentData + "." + data.attributes["puredata"].value + "}");
          }
        }
      }
    }
  }
}
